import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getExperiences } from '../../../store/reducers';
import style from './style.css';
// import CardsCarousel from '../cardscarousel';
import ScrollingExperiences from '../scrollingexperiences';

class Experiences extends Component {
    
    render() {
        return this.props.browser
            ? <ScrollingExperiences highlights={this.props.highlights } />
            : <div></div> 
    }
}
//? ( this.props.browser.greaterThan.medium ? <CardsCarousel experiences={this.props.experiences} /> : <ScrollingExperiences experiences={this.props.experiences } />  )

export default connect( 
    state =>({
        browser: state.browser,
        highlights: state.app.highlights
    })
)(Experiences);



// WEBPACK FOOTER //
// ./src/components/homescreen/experiences/index.js